import React, {Component, useState, useEffect} from "react";
import SyncLoader  from "react-spinners/SyncLoader";
import Reward from "./stakingComp/reward";
import RewardDashboard from "./stakingComp/rewardDashboard";
import StakeWallet from "./stakingComp/stakeWallet";
import UnStakeWallet from "./stakingComp/unStakeWallet";

function LP (){
       
    const [loading, setLoading] = useState(false);

    useEffect(() => {
        setLoading(true) 
        setTimeout(() => {
            setLoading(false)
        }, 3000)
    }, [])

    return (
        <React.Fragment>

            {loading ? 
             
             <div className="animation_widget">
                 <SyncLoader 
                 loading={loading}
                 size={30} 
                 color = {"yellow"}
                  />
             </div>

             :

             <React.Fragment>
                 <RewardDashboard />
                 <div className="rounds-flex staking-flex">
                    <StakeWallet />
                    <UnStakeWallet />
                 </div>
                 <Reward />
             </React.Fragment>

            }
        
        </React.Fragment>
    )
}

export default LP;